import { render, staticRenderFns } from "./StaffTableCard.vue?vue&type=template&id=58c3c6c4&scoped=true"
import script from "./StaffTableCard.vue?vue&type=script&lang=ts"
export * from "./StaffTableCard.vue?vue&type=script&lang=ts"
import style0 from "./StaffTableCard.vue?vue&type=style&index=0&id=58c3c6c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c3c6c4",
  null
  
)

export default component.exports